import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import GoogleSignIn from "../components/GoogleSignIn";
import cinesisLogo from "../assets/cinesis-logo.png";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  // If user is already logged in, redirect to home
  React.useEffect(() => {
    if (user) {
      navigate("/load-search");
    }
  }, [user, navigate]);

  return (
    <div
      className="login-card"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--surface)",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "var(--background)",
          padding: "40px",
          borderRadius: "16px",
          boxShadow: "var(--shadow)",
          maxWidth: "400px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Cinesis Cube Logo SVG */}
        <div
          style={{
            width: 130,
            height: 130,
            background:
              "linear-gradient(135deg, var(--primary), var(--secondary))",
            mask: `url(${cinesisLogo}) center/contain no-repeat`,
            WebkitMask: `url(${cinesisLogo}) center/contain no-repeat`,
            margin: "auto",
            marginBottom: "20px",
          }}
        />

        <h1
          style={{
            fontSize: "32px",
            marginBottom: "8px",
            color: "var(--text)",
          }}
        >
          Welcome to Cinesis
        </h1>

        <p
          style={{
            fontSize: "16px",
            color: "var(--muted)",
            marginBottom: "32px",
          }}
        >
          Sign in to access your account
        </p>

        <div style={{ marginBottom: "24px" }}>
          <GoogleSignIn />
        </div>

        <p
          style={{
            fontSize: "14px",
            color: "var(--muted)",
            marginTop: "24px",
          }}
        >
          By signing in, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
}
